import { Section } from 'components/section'
import { Animation } from './animation'
import { ColoredTitle } from 'components/colored-title'
import { Light } from 'styles/typography'
import PhoneNumbers from './phone-numbers'
import ContactInfo from 'components/contact-info'
import { ChapterFooter } from 'components/layout/chapter-footer'
import { authors } from './footer-data'

import coloredTitleA_L from './images/ColoredTitle5A_L.webp'
import coloredTitleA_M from './images/ColoredTitle5A_M.webp'
import coloredTitleA_S from './images/ColoredTitle5A_S.webp'
import coloredTitleB_L from './images/ColoredTitle5B_L.webp'
import coloredTitleB_M from './images/ColoredTitle5B_M.webp'
import coloredTitleB_S from './images/ColoredTitle5B_S.webp'
import { ParallaxBook } from './parallax/book'
import { ParallaxHand } from './parallax/hand'

export const Uzbekistan = () => {
  return (
    <>
      <Animation />
      <Section containerType="text">
        <p>
          Узбекистан – страна, где патриархальные устои долгое время были
          основой общества и передавались из поколения в поколение. Здесь, как и
          в других странах Центральной Азии, родители часто выбирают для дочерей
          будущего мужа, оценивая прежде всего не его характер, а социальный
          статус, финансовое положение и общественное признание.
        </p>
        <p>
          То же случилось и с Иродой (имя изменено), когда родители выбрали ей в
          мужья незнакомого мужчину, служившего в государственной безопасности,
          из "хорошей семьи".
        </p>
        <p>
          В этих отношениях Ирода подвергалась насилию, унижениям и изменам в
          течение 25 лет. Однако она смогла уйти от своего мужа, построить
          бизнес с нуля и научиться верить в себя. Сегодня она помогает другим
          женщинам победить насилие и начать жизнь заново.
        </p>
        <p>
          <Light>
            Предупреждение: в материале присутствуют описания сцен насилия
          </Light>
        </p>
        <p>
          Этот материал – часть проекта{' '}
          <a
            href="https://voicesofthebrave.asia/"
            target="_blank"
            rel="noreferrer"
          >
            "Голоса смелых"
          </a>
          , посвященного гендерному насилию в Центральной Азии. Мы рассказываем
          истории женщин, переживших насилие, чтобы показать масштаб проблемы и
          дать голос тем, кто зачастую говорить не может.
        </p>
      </Section>
      <Section containerType="text" heading="Замуж по принуждению">
        <p>
          Ирода с детства воспитывалась в консервативных традициях. В ее семье
          отношения между мужчинами и женщинами строго контролировались. Отец
          запрещал дочери даже общаться с мальчиками, не говоря уже о свиданиях
          или подарках. Он говорил, что ни одно благословение он ей не даст.
          Благословение родителей в узбекских семьях является очень важным. Это
          ритуал, символизирующий одобрение семьи и стремление сохранить
          гармонию в отношениях. Если благословение не получено, это может
          восприниматься как нарушение традиций и отсутствие уважения к старшим,
          что негативно скажется на восприятии брака в семье и обществе.
        </p>
        <p>
          Ирода рассказывает, что с юности чувствовала, что любовь для нее – это
          что-то недоступное, запрещенное. Когда пришел момент думать о
          замужестве, выбор за нее сделали родители, сосватав сына коллеги
          матери.
        </p>
        <p>
          "Моя мама работала с будущей свекровью. Она часто говорила о своем
          сыне. Очень успешный, презентабельный. Конечно, мама была впечатлена",
          – вспоминает Ирода.
        </p>
        <p>
          С этого момента разговоры о нем стали постоянными. Через несколько лет
          этих обсуждений, когда Ироде исполнилось 20 лет, ее познакомили с
          Шухратом (имя изменено). Он работал в органах безопасности, что, по
          мнению родителей Ироды, уже было подтверждением его надежности: если
          человека приняли в такие структуры, значит, его проверили и доверили
          государственные дела, считали они.
        </p>
        <p>
          Так всего через четыре месяца после знакомства Ирода вышла замуж. Все
          ее сомнения – внутренние "звоночки", связанные с его агрессией и
          раздражительностью, – проигнорировали. Родители убедили дочь, что в
          женихе главное – это его образование, стабильная работа и подходящая
          семья. На некоторое время Ирода поверила в это.
        </p>
      </Section>
      <Section
        containerType="text"
        heading="Из защитника в насильники"
        beforeTitle={<ParallaxBook />}
      >
        <p>
          Спустя месяц после замужества Ирода впервые столкнулась с физическим
          насилием. Для нее это было больно и неожиданно. В своей семье она
          всегда чувствовала защиту отца. Став женой, она надеялась, что муж
          будет выполнять роль защитника в ее жизни, но вместо этого Шухрат
          оказался источником угрозы, говорит она.
        </p>
        <p>
          Ссора началась с того, что Ирода пожаловалась свекрови на мужа: он
          слишком много пьет, не может справиться с рвотным рефлексом и не
          успевает добежать до туалета. Для девушки, выросшей в семье, где
          алкоголь был под строжайшим запретом, это было неприемлемо.
        </p>
        <p>
          Свекрови, жившей с молодоженами, хоть и не понравились претензии
          невестки, но все же она вмешалась и отчитала сына. Шухрат, в свою
          очередь, в ответ начал бить жену.
        </p>
        <p>
          "Меня удивило, что свекровь не защитила меня. Она стояла в стороне и
          говорила: "Зачем ты ее бьешь? Не бей, сынок, не надо". Но оттащить его
          от меня даже не попыталась", – вспоминает женщина.
        </p>

        <ParallaxHand />

        <p>С тех пор любые ее возражения заканчивались насилием.</p>
        <p>
          Дети были одной из главных мотиваций для нее сохранить семью. Спустя
          год совместной жизни в семье родился старший сын. Еще через два года
          родился второй сын.
        </p>
        <p>
          Но насилие в семье продолжалось – теперь к физическим побоям
          прибавился экономический и психологический абьюз. После двух
          беременностей подряд Ирода не могла сосредоточиться на карьере.
          Несколько лет она работала на государственной службе, но ее зарплаты
          не хватало. Муж только изредка давал ей деньги на личные нужды, когда
          был в хорошем настроении. В остальное время все ее просьбы
          заканчивались фразой: "У меня их тоже нет". Ирода привыкла к этому, но
          финансово часто помогали ее родители.
        </p>
        <p>
          Время шло, и через несколько лет женщина забеременела третьим
          ребенком. Однако рядом с мужем она не чувствовала тепла. Однажды,
          собравшись с силами, она спросила Шухрата, любит ли он ее. Ответ мужа
          был ошеломляющим: "Женщинам нельзя говорить такие вещи, а то они
          начинают борзеть".
        </p>
      </Section>

      <ColoredTitle src={[coloredTitleA_S, coloredTitleA_M, coloredTitleA_L]} />

      <Section containerType="text">
        <p>
          Со временем Ирода стала замечать, как муж все чаще задерживается на
          работе, не интересуется ее жизнью, постоянно говорит по телефону с
          кем-то, а ее вопросы встречает лишь агрессией. Оказалось, что у мужа
          на протяжении всего их брака была любовница, она даже присутствовала
          на их свадьбе. С ней он вел двойную жизнь и растил тайного ребенка.
        </p>
        <p>
          "Он, возможно, и женился бы на ней, но боялся родителей. Знал, что они
          никогда не одобрят межнациональный брак", – рассказывает Ирода.
        </p>
        <p>
          Она обратилась к родителям в поисках поддержки, но вместо этого
          услышала: "Ну что, все мужчины гуляют, терпи. Мудрая женщина на многие
          вещи глаза закрывает, зато у тебя семья, муж есть".
        </p>
        <p>
          Муж не стал отрицать своих измен. К тому времени его доходы
          увеличились, и он мог покупать дорогие подарки для жены, словно
          пытаясь откупиться за свои поступки. Когда она в очередной раз
          выразила недовольство, Шухрат схватил ее за руку и потянул к
          холодильнику, крича: "Чего тебе не хватает? Я тебе все дал, молчи,
          терпи!"
        </p>
        <p>
          После этого Ирода стала искать выход и поддержку. Сначала она
          устроилась работать на государственную службу, начала откладывать
          деньги. Когда она обратилась за помощью к психологу, то осознала, что
          находится в абьюзивных отношениях. Одним из неожиданных откровений в
          терапии для Ироды стало понятие о личных границах. Так она начала
          открывать себя и свои потребности.
        </p>
      </Section>
      <Section containerType="text" heading="Замкнутый круг насилия">
        <p>
          С помощью психолога Ирода поняла, что она лишена базового чувства
          безопасности. В стенах своего дома Ирода регулярно подвергалась
          насилию. Муж мог устроить скандал по любому поводу, и эта
          нестабильность вызывала страх и растерянность.
        </p>
        <p>
          Ирода говорит, что в раннем детстве сам Шухрат тоже страдал от насилия
          от своих родителей.
        </p>
        <p>
          "Супруг рассказывал, как в детстве с ним жестоко обращался отец. В
          возрасте 6—7 лет его могли голым выставить в наказание на площадку,
          избивали до такой степени, что он прятался под бардачок машины. Или
          запирали в темную комнату. Сейчас я понимаю, какая это травма была для
          него", – делится Ирода.
        </p>
        <p>
          Международная экспертка по вопросам гендерного равенства Аида
          Альжанова объясняет, что насилие часто передается из поколения в
          поколение в одной семье. Дети, растущие в атмосфере насилия, усваивают
          его как норму и во взрослой жизни либо становятся агрессорами, либо
          снова оказываются в роли жертвы.
        </p>
        <p>
          По ее словам. этот цикл закрепляется через социальное научение (когда
          насилие воспринимается как естественная часть семейной жизни),
          психологическую адаптацию и выученную беспомощность.
        </p>
        <p>
          "Если ребенок видит, что его мать не может уйти от насильника, у него
          формируется убеждение, что бороться бесполезно. В дальнейшем это
          приводит к пассивному принятию насилия. Это создает замкнутый круг,
          который сложно разорвать без внешнего вмешательства – образования,
          психологической помощи и изменения общественных норм и законов", –
          объясняет Аида Альжанова.
        </p>
        <p>
          Насилие в семье Ироды сказалось и на здоровье детей. У старшего сына
          начались панические атаки. У второго диагностировали диабет первого
          типа, а младшая дочь до шести лет страдала энурезом.
        </p>
      </Section>
      <Section
        containerType="text"
        heading='"Если я так долго терпела, они не должны повторять мои ошибки"'
      >
        <p>
          Только когда дети подросли, Ирода почувствовала, что пришел и ее
          момент. Увлечение модой сопровождало ее всю жизнь, но настоящая
          страсть вспыхнула, когда она по приглашению подруги попала на фабрику
          одежды в Ферганской долине.
        </p>
        <p>
          Рассматривая ткани, изучая их структуру, она стала видеть мир в новых
          цветах и формах, словно каждый элемент создавал в ее голове
          стилистическую картину, вспоминает она.
        </p>
        <p>
          Увидев ее интерес, сотрудники фабрики пригласили Ироду работать
          дизайнером и заниматься административной работой.
        </p>
        <p>
          "Я была счастлива, – вспоминает она. – Начала хорошо зарабатывать,
          чувствовала, как растет уверенность в себе. Все получалось, я
          вкладывала силы и знания, инвестировала в себя. Думаю, это лучшее, что
          женщина может сделать для себя и своих детей".
        </p>
        <p>
          Мужу все это не нравилось. Он ушел на пенсию, потерял свою финансовую
          стабильность и утратил прежний социальный статус. Каждый шаг жены
          вперед Шухрат воспринимал как угрозу своему положению. Он упрекал ее,
          когда она тратила деньги на маникюр или косметические процедуры и
          пытался унизить, называя все это "пустыми" удовольствиями. Все это
          время насилие со стороны Шухрата продолжалось.
        </p>
        <p>
          Несмотря на постоянные ссоры, Ирода искренне хотела сохранить семью,
          говорит она. Она пыталась говорить с мужем, предлагала читать
          литературу по саморазвитию, ходить к психологу, но на все ее усилия он
          отмахивался, утверждая, что с ним все в порядке, а что-то не так
          именно с ней.
        </p>
      </Section>

      <ColoredTitle src={[coloredTitleB_S, coloredTitleB_M, coloredTitleB_L]} />

      <Section containerType="text">
        <p>
          "Ему просто не нравилось, что я перестала молчать. Для него это было
          ненормально", – говорит Ирода, вспоминая самые тяжелые ссоры.
        </p>
        <p>
          После очередной серии скандалов у среднего сына Ироды выявили диабет
          первого типа: он сильно переживал, нервничал и каждую ссору родителей
          принимал близко к сердцу. Это стало для Ироды последней каплей. Она
          спросила себя: для чего она пытается сохранять семью.
        </p>
        <p>
          "Я против разрушения брака, если в нем есть перспектива и
          положительная динамика, если тебя слышат. Но в моем случае все было
          иначе", – рассказывает она.
        </p>
        <p>
          Решение уйти ей далось нелегко. 25 лет совместной жизни, накопленное
          имущество и деньги, общий просторный дом – оставить все и уйти в
          неизвестность было страшно. Ирода говорит, что ей не хотелось, чтобы
          дети, создавая свои семьи, помнили, что родители в разводе.
        </p>
        <p>
          Во время одной из встреч психолог спросил: "Хотела бы ты, чтобы твоя
          дочь прожила жизнь в браке, оставаясь жертвой?" Этот вопрос "сильно
          отрезвил" Ироду.
        </p>
        <p>
          "Нет, я не хотела бы этого. Я хотела, чтобы мои дети понимали: насилие
          – это ненормально. Если я так долго терпела, они не должны повторять
          мои ошибки", – делится она.
        </p>
        <p>
          Когда Ирода сказала супругу о решении развестись, он стал запирать ее
          в комнате, забирать ключи от дома и машины.
        </p>
        <p>
          Уход пришлось тщательно планировать. Незаметно упаковав нужные вещи и
          дождавшись, пока мужа не будет дома, Ирода взяла младшую дочь и тихо
          покинула дом. Она въехала в небольшую квартиру, которую они с Шухратом
          купили в браке и сдавали в аренду.
        </p>
        <p>
          "Мне не нужен был большой дом с [мужем], я ушла и радовалась. Теперь я
          почувствовала счастье!" – говорит Ирода.
        </p>
        <p>
          Возвращаться она не собиралась. Для нее осталась позади жизнь, в
          которой за нее все решали, где ее критиковали, унижали и били.
        </p>
        <p>
          Старшие совершеннолетние сыновья временно остались с отцом, но
          полностью поддержали маму в ее решении. Позже и они переехали к ней,
          почувствовав, что с матерью им будет безопаснее.
        </p>
        <p>
          Из-за табуированности темы насилия в отношении женщин, оценить
          реальный масштаб проблемы в Узбекистане сложно. Статистика по насилию
          в отношении женщин не является полной и зачастую недоступна в
          Узбекистане.
        </p>
        <p>
          Из имеющихся{' '}
          <a
            href="https://www.gazeta.uz/ru/2022/04/26/violence/"
            target="_blank"
            rel="noreferrer"
          >
            данных
          </a>{' '}
          можно сделать вывод, что самыми распространенными формами насилия
          являются физическое и психологическое. Например, в 2021 году
          зарегистрировали 13658 и 18777 случаев соответственно. Зачастую эти
          два вида насилия сопровождают друг друга.
        </p>
        <p>
          В 2023 году по административной статье о домашнем насилии в стране
          привлекли почти девять тысяч человек. Из них больше половины{' '}
          <a
            href="https://www.gazeta.uz/ru/2024/02/12/domestic-violence/"
            target="_blank"
            rel="noreferrer"
          >
            получили
          </a>{' '}
          штраф, а 3699 человек – административный арест.
        </p>
        <p>
          В том же 2023 году власти Узбекистана криминализировали домашнее
          насилие. Однако правозащитники{' '}
          <a
            href="https://eurasia.amnesty.org/2023/04/06/parlament-uzbekistana-prinyal-davno-nazrevshij-zakon-ob-ugolovnoj-otvetstvennosti-za-nasilie-v-seme/"
            target="_blank"
            rel="noreferrer"
          >
            говорят
          </a>
          , что в Уголовный кодекс включает в себя только физическое насилие, в
          то время как психологическое и экономическое "остается без должного
          внимания".
        </p>
      </Section>
      <Section containerType="text" heading='"Я стала лучшей версией себя"'>
        <p>
          Ироде потребовалась время, чтобы прийти в себя. Сейчас она признается,
          что прошедшие испытания не сломили ее, а сделали сильнее и закалили
          характер.
        </p>
        <p>
          Наконец на деньги, которые она ранее смогла накопить, Ирода открыла
          свой бизнес в сфере моды и шитья – занятии, которое приносило ей
          невероятное удовольствие. Дети поддержали и всячески помогали ей,
          особенно в первые месяцы создания бизнеса.
        </p>
        <p>
          На свои сбережения женщина купила первые швейные машинки и сырье, а
          также наняла SMM-специалиста. Сейчас в ее команде несколько человек, а
          их продукция пользуется спросом в Узбекистане и западных странах.
        </p>
        <p>
          Для многих женщин Ирода стала примером. Сейчас она не только ведет
          свой бизнес, но и старается помочь другим – ведет тренинги о том, как
          открыть свой бизнес с нуля, а также занимается благотворительностью.
        </p>
        <p>
          "Я стала лучшей версией себя, – делится Ирода. – Я живу жизнью, о
          которой всегда мечтала, и вдохновляю женщин в своем окружении на
          обретение независимости, уверенности в себе, самостоятельности и
          внутренней гармонии".
        </p>
        <p>
          Если вы столкнулись с насилием в Узбекистане, вы можете обратиться в
          следующие организации за помощью:
        </p>
      </Section>
      <PhoneNumbers />
      <ContactInfo />

      <ChapterFooter authors={authors} />
    </>
  )
}
